var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-overlay" }, [
    _c("div", { staticClass: "login-overlay__wrapper" }, [
      _c("div", { staticClass: "login-overlay__container" }, [
        _c("div", { staticClass: "login-overlay__info" }, [
          _c("h2", {
            domProps: { innerHTML: _vm._s(_vm.$t("login.brandsTitle")) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "migration__text",
            domProps: { innerHTML: _vm._s(_vm.$t("login.brandsText")) }
          }),
          _vm._v(" "),
          _vm.brands.length
            ? _c("h3", {
                domProps: { innerHTML: _vm._s(_vm.$t("login.brandsSubtitle")) }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.brands.length
            ? _c(
                "ul",
                { staticClass: "migration__brands migration__brands--all" },
                _vm._l(_vm.brands, function(brand) {
                  return _c(
                    "li",
                    {
                      key: brand.code,
                      staticClass: "migration__brand migration__brand--all"
                    },
                    [
                      _c(_vm.iconComponent("logo-simple-" + brand.code), {
                        tag: "component",
                        staticClass: "migration__brand-logo"
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "login-overlay__options" }, [
          _c("div", { staticClass: "login-overlay__tabs" }, [
            _c("button", {
              staticClass: "login-overlay__tab",
              class: {
                "login-overlay__tab--active": _vm.activeTab == "login"
              },
              attrs: { type: "button" },
              domProps: { innerHTML: _vm._s(_vm.$t("login.loginTab")) },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.setActiveTab("login")
                }
              }
            }),
            _vm._v(" "),
            _c("button", {
              staticClass: "login-overlay__tab",
              class: {
                "login-overlay__tab--active": _vm.activeTab == "register"
              },
              attrs: { type: "button" },
              domProps: { innerHTML: _vm._s(_vm.$t("login.registerTab")) },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.setActiveTab("register")
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab == "login",
                  expression: "activeTab == 'login'"
                }
              ],
              staticClass: "login-overlay__tab-content"
            },
            [
              _c("FormLogin", {
                ref: "loginForm",
                attrs: { "hide-title": "" },
                on: { loggedIn: _vm.onLoggedIn }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab == "register",
                  expression: "activeTab == 'register'"
                }
              ],
              staticClass: "login-overlay__tab-content"
            },
            [
              _c("FormRegister", {
                ref: "registerForm",
                attrs: { "hide-title": "" }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }